import React from "react";
import { useScrollToTop } from "hooks/useScrollToTop";

/**
 * Component that scrolls to top on route changes
 * Wrap your Routes with this component to enable scroll-to-top behavior
 */
export const ScrollToTop: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useScrollToTop();
  return <>{children}</>;
};

export default ScrollToTop;
